import { render, staticRenderFns } from "./AddOptionModal.vue?vue&type=template&id=64416f74&scoped=true&"
import script from "./AddOptionModal.vue?vue&type=script&lang=js&"
export * from "./AddOptionModal.vue?vue&type=script&lang=js&"
import style0 from "./AddOptionModal.vue?vue&type=style&index=0&id=64416f74&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64416f74",
  null
  
)

export default component.exports